module.exports = __webpack_public_path__ + "img/12.202d7012.png";